import { AsyncFeatureFlagGate } from "./auth-fe13.esm.js";
import AccountForm$1 from "./auth-fe23.esm.js";
import { AccountFormV2 } from "./auth-fe24.esm.js";
import React from "react";
import { Loader } from "@opendoor/bricks-next";
//#region src/AccountForm/AccountForm.tsx
var AccountForm = ({ accountFormProps, featureFlagProps }) => {
	const { flag = "auth-fe-account-form", loading = /* @__PURE__ */ React.createElement(Loader, { size: "small" }), ...flagProps } = featureFlagProps;
	return /* @__PURE__ */ React.createElement(AsyncFeatureFlagGate, {
		flag,
		disabled: /* @__PURE__ */ React.createElement(AccountForm$1, accountFormProps),
		enabled: /* @__PURE__ */ React.createElement(AccountFormV2, accountFormProps),
		loading,
		...flagProps
	});
};
//#endregion
export { AccountForm };

